import React from 'react';
import { A } from '../../common';
import { URL } from '../../../constant';
import { useAppOcrOnOff, useProfessorK } from '../../../hooks';
import Header from './Header';
import PMNotice from './PMNotice';

function AibarosamGroupOne(props) {
  const { handleOcr } = useAppOcrOnOff();
  const {handleProfessorKOpen} = useProfessorK();

  return (
    <React.Fragment>
      <Header />
      <div className="layout-def with_bottom_area choice gm new grade flex_main">
        <div className="container">
          <div className="inner">
            <div className="center_wrap ">
              <PMNotice />
              <div className="boxes_wrap">
                <A 
                  className="box1 js_play_audio1" 
                  onClick={() => props.handlePage(URL.PROGRESS_LEARNING.AI_BAROSEM)}
                >
                </A>
                <A 
                  className="box2"
                  onClick={() => props.handlePage(URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.ENTER_LEARNER_DATA)}
                >AI 진단테스트
                </A>
                <A 
                  className="box3 js_play_audio1" 
                  href="#null"
                  onClick={() => props.handlePage(URL.TOPIC_LEARNING)}
                >
                  <span><strong>주제</strong>학습</span>
                </A>
                <A 
                  className="box4" 
                  onClick={handleOcr}
                >
                  <span>OCR 학습</span>
                </A>
              </div>
              <div class="banner_wrap">
                <A class="banner_link" onClick={handleProfessorKOpen}>
                  <span class="blind">프로페서 K 시간 여행으로 즐기는 사고력 수학 - 시작하기</span>
                </A>

                <A class="b_product_link" onClick={() => props.handlePage(URL.INTRODUCTION)}>
                  <span class="b_product_link_badge">제품소개 바로가기</span>
                  <p class="b_product_link_tit">강력한 AI 기술로 완성된</p>
                  <p class="b_product_link_subtit">새로운 연산 학습법! AI 바로셈!</p>
                </A>
              </div>
            </div>
            <div className="bottom_wrap btn_wrap flexible_bottom_banner">
              <div className="box_btn">
                <span className="inner_box cls">
                  <span className="left">
                    <span className="txt1">강력한 AI 기술로 완성된</span>
                    <span className="txt2">새로운 연산 학습법! AI 바로셈!</span>
                  </span>
                  <img className="img_lg_btm_ca" src="./static/images/common/img_lg_btm_ca.svg" alt="" />
                  <A
                    className="right"
                    onClick={() => props.handlePage(URL.INTRODUCTION)}
                  >
                    제품소개 바로가기
                  </A>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </React.Fragment>
  );
}

export default AibarosamGroupOne;